export enum ENUMERATOR_STATUS {
  AVAILABLE = "available",
  NOT_AVAILABLE = "not-available",
}
